import { Box, Skeleton } from '@mui/material';

const helperRenderSkeleton = () =>
    Array.from({ length: 4 }).map((_, index) => (
        <Skeleton
            key={index}
            variant="rectangular"
            height="66px"
            sx={{
                mb: '12px',
                borderRadius: '12px',
            }}
        />
    ));

export const SkeletonDragAndDrop = () => (
    <Box
        sx={{
            width: '100%',
        }}
    >
        <Skeleton
            variant="rectangular"
            height="20px"
            sx={{
                mb: '16px',
                borderRadius: '6px',
            }}
        />
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            {helperRenderSkeleton()}
        </Box>
    </Box>
);
